const baseUrl = 'https://cdn.shopify.com/s/files/1/0515/9557/5474/files/';

const lightPlayerWaveTop = [216, 255, 0];
const lightPlayerWaveBottom = [140, 140, 140];
const lightHorizonColor = [220, 220, 220];
const darkPlayerWaveTop = [27, 27, 27];
const darkPlayerWaveBottom = [125, 125, 125];
const darkHorizonColor = [160, 160, 160];

const smallPlayerHeight = 30;
const largePlayerHeight = 100;

let waveSurferObjects = [];

// Define gradients
const waveGradient = (height, colorScheme, opacity) => {
  let myWaveTopColor;
  let myWaveBottomColor;
  let myHorizonColor;

  if (colorScheme === 'light') {
    myWaveTopColor = `rgba(${lightPlayerWaveTop[0]}, ${lightPlayerWaveTop[1]},${lightPlayerWaveTop[2]}, ${opacity})`;
    myHorizonColor = `rgba(${lightHorizonColor[0]}, ${lightHorizonColor[1]},${lightHorizonColor[2]}, ${opacity})`;
    myWaveBottomColor = `rgba(${lightPlayerWaveBottom[0]}, ${lightPlayerWaveBottom[1]},${lightPlayerWaveBottom[2]}, ${opacity})`;
  } else {
    myWaveTopColor = `rgba(${darkPlayerWaveTop[0]}, ${darkPlayerWaveTop[1]},${darkPlayerWaveTop[2]}, ${opacity})`;
    myHorizonColor = `rgba(${darkHorizonColor[0]}, ${darkHorizonColor[1]},${darkHorizonColor[2]}, ${opacity})`;
    myWaveBottomColor = `rgba(${darkPlayerWaveBottom[0]}, ${darkPlayerWaveBottom[1]},${darkPlayerWaveBottom[2]}, ${opacity})`;
  }
  let myGrad = document
    .createElement('canvas')
    .getContext('2d')
    .createLinearGradient(0, 0, 0, height);
  myGrad.addColorStop(0.4999, myWaveTopColor);
  myGrad.addColorStop(0.5, myHorizonColor);
  myGrad.addColorStop(0.7, myWaveBottomColor);
  return myGrad;
};

const playPauseSong = index => {
  waveSurferObjects.forEach((ws, count) => {
    if (index === count) {
      ws.playPause();
    } else {
      ws.pause();
    }
  });
};

// Initialize Players
// const productId = myWSPlayerProductId;
if (typeof myWSPlayerProductId !== 'undefined') {

  const players = Array.from(document.getElementsByClassName('ws-player'));
  players.forEach((player, index) => {
    const myWaveForm = player.querySelector('.ws-player-waveform');
    const myNo = player.getAttribute('no');
    myWaveForm.id = `waveform${myNo}`;

    const myColorScheme = player.getAttribute('colorscheme');
    const mySize = player.getAttribute('size');
    const myButton = player.querySelector('.ws-player-btn');
    myButton.setAttribute('onClick', `playPauseSong(${index})`);
    if (myColorScheme === 'dark') {
      myButton.classList.add('dark');
    }
    let myHeight;
    if (mySize === 'small') {
      myHeight = smallPlayerHeight;
    } else {
      myHeight = largePlayerHeight;
    }
    const myWaveSurfer = WaveSurfer.create({
      container: `#waveform${myNo}`,
//       waveColor: waveGradient(myHeight, myColorScheme, 0.5),
//       progressColor: waveGradient(myHeight, myColorScheme, 1.0),
      waveColor: "#d6ff0080",
      progressColor: "#D6FF00",
      responsive: '100',
      hideScrollbar: 'true',
      barWidth: 3,
      barMinHeight: 0.5,
      height: myHeight,
      cursorWidth: 0,
      normalize: true,
    });
	myWaveSurfer.on('seek', () => {
      if (myWaveSurfer.isPlaying()) {
        myWaveSurfer.play();
      }
    });
    myWaveSurfer.on('pause', () => {
      myButton.innerHTML = '<i class="fas fa-play"></i>';
    });

    myWaveSurfer.on('play', () => {
      myButton.innerHTML = '<i class="fas fa-pause"></i>';
    });

    try {
      myWaveSurfer.load(`${baseUrl}${myWSPlayerProductId}_${myNo}.mp3`);
      
      // console.log(`${index}. ${baseUrl}${myWSPlayerProductId}_${myNo}.mp3`);
      
    } catch {
      console.log(`Can not load ${baseUrl}${myWSPlayerProductId}_${myNo}.mp3`);
    }

    waveSurferObjects.push(myWaveSurfer);
  });
}
